// Re-export of `sonner`'s `toast` that ALSO funnels error & warning calls
// into our central error log. Use this everywhere instead of importing
// `sonner` directly so the capture wrapping happens automatically.
//
//   import { toast } from "@/lib/toast";
//
// Only the .error and .warning variants are intercepted (per user spec —
// success/info toasts are noise in the error feed).
import { toast as sonnerToast } from "sonner";
import { logError } from "@/lib/errorCapture";

function extractMessage(arg) {
  if (arg == null) return "(empty toast)";
  if (typeof arg === "string") return arg;
  if (typeof arg === "number" || typeof arg === "boolean") return String(arg);
  if (arg instanceof Error) return arg.message;
  try { return JSON.stringify(arg); } catch { return String(arg); }
}

function wrap(severity, fn) {
  return function (message, opts) {
    try {
      logError({
        severity,
        source: "toast",
        message: extractMessage(message),
        extra: opts && opts.description ? { description: extractMessage(opts.description) } : null,
      });
    } catch {
      /* never let logging break a toast */
    }
    return fn(message, opts);
  };
}

// Build a proxy that exposes the same API as `sonner`'s toast — calling it
// as a function works (info toast) and every named variant is preserved.
function callable(message, opts) {
  return sonnerToast(message, opts);
}
Object.assign(callable, sonnerToast);
callable.error = wrap("error", sonnerToast.error.bind(sonnerToast));
callable.warning = wrap("warning", sonnerToast.warning.bind(sonnerToast));

export const toast = callable;
